import { type FunctionComponent } from "react";
import { ChatInterface } from "../../components/chat/chat-interface";
import { PredefinedTasks } from "../../components/predefined-tasks/predefined-tasks";

export const MainContent: FunctionComponent = () => {
  return (
    <div className="flex flex-col flex-1 h-full overflow-hidden">
      <PredefinedTasks className="hidden sm:block sm:mb-6" />
      <ChatInterface className="pt-6 sm:pt-0" />
    </div>
  );
};
